import styled from 'styled-components';

import Dialog from '@material-ui/core/Dialog';
import { colors } from '@lavu-pos/stellar/dist/themes';
import { StellarTheme, Button } from '@lavu-pos/stellar';

const muiBreakpoint = 'sm';

export const SwitchCP4Dialog = styled(Dialog).attrs({
	classes: {
		paper: 'customPaper',
	},
})`
	.customPaper {
		padding: 20px 30px;
		${StellarTheme.breakpoints.up(muiBreakpoint)} {
			padding: 32px 48px;
		}
	}
`;

export const DialogTitle = styled.div`
	.subtitle {
		font-size: 14px;
	}
`;

export const DialogContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	.icon {
		width: 32px;
		height: 32px;
		margin-right: 24px;
	}

	.section {
		display: flex;
		margin-top: 28px;
		${StellarTheme.breakpoints.up(muiBreakpoint)} {
			margin-top: 24px;
		}
	}

	.description {
		display: flex;
		flex-direction: column;
		${StellarTheme.breakpoints.up(muiBreakpoint)} {
			display: grid;
			grid-template-columns: 150px auto;
		}
	}

	.actionsContainer {
		margin-top: auto;
		display: flex;
		justify-content: flex-end;
	}

	.sections {
		margin-bottom: 40px;
	}
`;

export const SectionTitle = styled.span`
	font-size: 17px;
	font-weight: 600;
	line-height: 1.41;
`;

export const SectionDescription = styled.span`
	font-size: 14px;
	line-height: 1.43;
	margin-top: 12px;
	max-width: 240px;

	${StellarTheme.breakpoints.up(muiBreakpoint)} {
		max-width: 220px;
		margin-top: 0px;
	}
`;

export const ConfirmButton = styled(Button)`
	&& {
		color: white;
		background-color: ${colors['purple-medium']};
		width: 168px;
		margin-left: 16px;
	}
`;

export const DismissButton = styled(Button)`
	&& {
		color: ${colors['purple-medium']};
		background-color: ${colors['dividerGray']};
		width: 168px;
	}
`;
